import React, { FC } from 'react';

import { TrailerPlayer } from '../../feature-player/ui/trailer/trailer-player/component';
import { Player } from '../../Player/Player';

interface MovieTrailerPlayerProps {
    contentId: string;
    onError?: () => void;
    onTrailerEnd?: () => void;
    onClose?: () => void;
}

export const MovieTrailerPlayer: FC<MovieTrailerPlayerProps> = ({
    contentId,
    onTrailerEnd,
    onClose,
    onError,
}) => (
    <Player
        onError={onError}
        onFinish={onTrailerEnd}
        onClose={onClose}
        contentId={contentId}
        renderPlayer={({
            contentId,
            onStartCallback,
            handleError,
            handleFinish,
            psid,
            onClose,
        }) => (
            <TrailerPlayer
                contentId={contentId}
                onContentImpression={onStartCallback}
                onFinish={handleFinish}
                onError={handleError}
                onClose={onClose}
                psid={psid}
            />
        )}
    />
);
